// Обработчики автоконструктора.

import type { DashboardSourceType } from '../state';
import { THEME_PRESETS } from '../../theme';
import { bindChoiceMirror, setChoiceSelection, updateChoiceCounter } from '../choice-lists';
import { closeAutoBuilder, createAutoDashboard, openAutoBuilder, refreshAutoBdmoTerritories, refreshAutoBuilderOptions, refreshAutoGenericTerritories, refreshAutoYears, renderAutoIndicatorChoices, renderAutoSectionOptions, updateAutoBuilderSelectionPreview } from '../autobuilder';
import { controls } from '../controls';
import { currentTheme } from '../theming';
import { state } from '../state';

let autoBuilderSearchTimer: number | undefined;

export function bindAutoBuilderEvents(): void {
  bindChoiceMirror(controls.autoTerritories, controls.autoTerritoryChoiceList);
  bindChoiceMirror(controls.autoYears, controls.autoYearChoiceList);
  bindChoiceMirror(controls.autoDistricts, controls.autoDistrictChoiceList);
  bindChoiceMirror(controls.autoRegions, controls.autoRegionChoiceList);
  bindChoiceMirror(controls.autoMunicipalities, controls.autoMunicipalityChoiceList);
  controls.autoBuilderButton.addEventListener('click', openAutoBuilder);
  controls.autoBuilderClose.addEventListener('click', closeAutoBuilder);
  controls.autoBuilderCancel.addEventListener('click', closeAutoBuilder);
  controls.autoBuilderCreate.addEventListener('click', () => void createAutoDashboard());
  controls.autoSource.addEventListener('change', () => {
    state.autoSelectedIndicatorKeys.clear();
    controls.autoSection.value = '';
    controls.autoIndicatorSearch.value = '';
    void refreshAutoBuilderOptions();
  });
  controls.autoSectionSearch.addEventListener('input', () => {
    renderAutoSectionOptions();
  });
  controls.autoSection.addEventListener('change', () => {
    state.autoSelectedIndicatorKeys.clear();
    controls.autoIndicatorSearch.value = '';
    void refreshAutoBuilderOptions();
  });
  controls.autoIndicatorSearch.addEventListener('input', () => {
    window.clearTimeout(autoBuilderSearchTimer);
    autoBuilderSearchTimer = window.setTimeout(() => void refreshAutoBuilderOptions(), 250);
  });
  controls.autoIndicatorChoiceList.addEventListener('change', (event) => {
    const input = (event.target as Element).closest<HTMLInputElement>('input[data-auto-indicator-key]');
    if (!input?.dataset.autoIndicatorKey) return;
    if (input.checked) state.autoSelectedIndicatorKeys.add(input.dataset.autoIndicatorKey);
    else state.autoSelectedIndicatorKeys.delete(input.dataset.autoIndicatorKey);
    renderAutoIndicatorChoices();
    const requestToken = ++state.autoBuilderRequestToken;
    const sourceType = controls.autoSource.value as DashboardSourceType;
    void (async () => {
      if (sourceType === 'bdmo') await refreshAutoBdmoTerritories(requestToken);
      else await refreshAutoGenericTerritories(sourceType, requestToken);
      await refreshAutoYears(sourceType, requestToken);
    })();
  });
  controls.autoPickEnabled.addEventListener('change', updateAutoBuilderSelectionPreview);
  controls.autoFillMissing.addEventListener('change', updateAutoBuilderSelectionPreview);
  controls.autoTerritorySearch.addEventListener('input', () => {
    updateChoiceCounter(controls.autoTerritories, controls.autoTerritorySearch, controls.autoTerritoryCounter);
  });
  controls.autoTerritorySelectAll.addEventListener('click', () => setChoiceSelection(controls.autoTerritories, true, true));
  controls.autoTerritoryClear.addEventListener('click', () => setChoiceSelection(controls.autoTerritories, false, false));
  controls.autoTerritories.addEventListener('change', () => {
    updateChoiceCounter(controls.autoTerritories, controls.autoTerritorySearch, controls.autoTerritoryCounter);
    updateAutoBuilderSelectionPreview();
  });
  controls.autoDistrictSearch.addEventListener('input', () => updateChoiceCounter(controls.autoDistricts, controls.autoDistrictSearch, controls.autoDistrictCounter));
  controls.autoRegionSearch.addEventListener('input', () => updateChoiceCounter(controls.autoRegions, controls.autoRegionSearch, controls.autoRegionCounter));
  controls.autoMunicipalitySearch.addEventListener('input', () => updateChoiceCounter(controls.autoMunicipalities, controls.autoMunicipalitySearch, controls.autoMunicipalityCounter));
  controls.autoDistrictSelectAll.addEventListener('click', () => setChoiceSelection(controls.autoDistricts, true, true));
  controls.autoDistrictClear.addEventListener('click', () => setChoiceSelection(controls.autoDistricts, false, false));
  controls.autoRegionSelectAll.addEventListener('click', () => setChoiceSelection(controls.autoRegions, true, true));
  controls.autoRegionClear.addEventListener('click', () => setChoiceSelection(controls.autoRegions, false, false));
  controls.autoMunicipalitySelectAll.addEventListener('click', () => setChoiceSelection(controls.autoMunicipalities, true, true));
  controls.autoMunicipalityClear.addEventListener('click', () => setChoiceSelection(controls.autoMunicipalities, false, false));
  controls.autoDistricts.addEventListener('change', () => void refreshAutoBdmoTerritories(++state.autoBuilderRequestToken));
  controls.autoRegions.addEventListener('change', () => void refreshAutoBdmoTerritories(++state.autoBuilderRequestToken));
  controls.autoMunicipalities.addEventListener('change', () => {
    updateChoiceCounter(controls.autoMunicipalities, controls.autoMunicipalitySearch, controls.autoMunicipalityCounter);
    updateAutoBuilderSelectionPreview();
  });
  controls.autoYearSearch.addEventListener('input', () => updateChoiceCounter(controls.autoYears, controls.autoYearSearch, controls.autoYearCounter));
  controls.autoYearSelectAll.addEventListener('click', () => setChoiceSelection(controls.autoYears, true, true));
  controls.autoYearClear.addEventListener('click', () => setChoiceSelection(controls.autoYears, false, false));
  controls.autoYears.addEventListener('change', () => {
    updateChoiceCounter(controls.autoYears, controls.autoYearSearch, controls.autoYearCounter);
    updateAutoBuilderSelectionPreview();
  });
  controls.autoColorPresets.addEventListener('click', (event) => {
    const button = (event.target as Element).closest<HTMLButtonElement>('[data-auto-color-preset]');
    if (!button) return;
    const preset = THEME_PRESETS[Number(button.dataset.autoColorPreset)];
    if (preset) controls.autoPrimaryColor.value = preset.primaryColor;
  });
  controls.autoColorReset.addEventListener('click', () => {
    controls.autoPrimaryColor.value = currentTheme().primaryColor;
  });
  controls.autoBuilderDialog.addEventListener('click', (event) => {
    if (event.target === controls.autoBuilderDialog) closeAutoBuilder();
  });
}
